// Golf 4 (Duits): Jouw gegevens (0036), weergave per tablet, wijzigingen weggooien,
// verwachte dagen, modules, werklijst en Ramadan op het bord. Zelfde vorm als de nl-bestanden; de
// stukken worden in app.de.ts, profileApp.de.ts, modulesApp.de.ts, werklijstApp.de.ts en
// weatherPrayer.de.ts ingehaakt. AMUMIN Beheer (beheerApp) blijft nl/en: alleen de oprichter.
export const appPrivacyRightsDe = {
    title: 'Deine Daten',
    intro: 'Alles herunterladen, jemanden aus der Familie nehmen oder die Familientafel löschen. Es sind eure Daten.',
    entry: 'Deine Daten',
    entryBody: 'Alles herunterladen, jemanden aus der Familie nehmen, die Familientafel löschen.',
    exportTitle: 'Alles herunterladen',
    exportBody: 'Eine ZIP-Datei mit allem über eure Familie: Mitglieder, Kalender, Aufgaben, Essen, Nachrichten, Angaben zu Fotos und die Auswahl unter Was zu unserer Familie passt. Mit einer lesbaren Zusammenfassung dazu.',
    exportOwnerOnly: 'Nur der Eigentümer der Familientafel kann alles herunterladen.',
    exportStart: 'Download vorbereiten',
    exportPending: 'Wir erstellen die Datei. Das dauert meist weniger als eine Minute.',
    exportReady: 'Fertig · {size} · herunterladbar bis {time}',
    exportOnce: 'Du kannst die Datei einmal herunterladen. Danach löschen wir sie.',
    exportDownload: 'Herunterladen',
    exportDownloaded: 'Heruntergeladen am {time}',
    exportExpired: 'Abgelaufen am {time}',
    exportFailed: 'Die Datei konnte nicht erstellt werden. Versuch es noch einmal.',
    exportAgain: 'Neu vorbereiten',
    exportMailed: 'Alle Eltern bekommen eine Mail, dass ein Download bereitsteht.',
    exportStarted: 'Wir erstellen die Datei',
    exportSaved: 'Die Datei ist in deinen Downloads',
    mineTitle: 'Nur deine eigenen Daten',
    mineBody: 'Deine eigenen Daten und das Familienprofil, das für dich gilt, als Datei (JSON).',
    mineButton: 'Meine Daten herunterladen',
    removeTitle: 'Jemanden aus der Familie nehmen',
    removeBody: 'Zum Beispiel ein Kind, das ausgezogen ist, oder ein Ex-Partner. Das geht unter Familie: Person öffnen und Aus der Familie nehmen wählen.',
    removeToMembers: 'Zu Familie',
    removeButton: 'Aus der Familie nehmen',
    removeConfirmTitle: '{name} aus der Familie nehmen?',
    removeConfirmNow: '{name} verschwindet sofort aus der App und von der Tafel. Hat {name} ein eigenes Login, funktioniert es für diese Familie nicht mehr.',
    removeConfirmLater: 'Du kannst das 7 Tage lang rückgängig machen. Danach anonymisieren wir {name}: Der Name wird „Ehemaliges Familienmitglied“, Foto, Geburtsdatum und besondere Daten (Glaube, Gesundheit, Schule) verschwinden, ebenso künftige Termine und Aufgaben. Was schon passiert ist, bleibt ohne Namen stehen.',
    removeConfirmProfile: 'Eigene Auswahl unter Was zu unserer Familie passt und beim Wetter wird sofort gelöscht und kommt beim Rückgängigmachen nicht zurück.',
    removeConfirmButton: 'Aus der Familie nehmen',
    removeButtonHouse: 'Aus dem Haus nehmen',
    removeConfirmTitleHouse: '{name} aus dem Haus nehmen?',
    removeConfirmNowHouse: '{name} verschwindet sofort aus der App und von der Tafel. Hat {name} einen eigenen Login, funktioniert er für dieses Zuhause nicht mehr.',
    removeConfirmLaterHouse: 'Du kannst das 7 Tage lang rückgängig machen. Danach machen wir {name} anonym: Der Name wird „{former}“, Foto und persönliche Daten verschwinden, ebenso künftige Termine und Aufgaben. Was schon passiert ist (auch Ausgaben), bleibt ohne Namen stehen.',
    removeConfirmProfileHouse: 'Eigene Einstellungen von {name} (etwa Essen und Wetter) werden sofort gelöscht und kommen beim Rückgängigmachen nicht zurück.',
    removeConfirmButtonHouse: 'Aus dem Haus nehmen',
    removeConfirmAnywayHouse: 'Trotzdem aus dem Haus nehmen',
    removedHouse: '{name} wurde aus dem Haus genommen',
    removeConfirmLinks: 'Kalenderlinks, die {name} erstellt hat (Google, Outlook oder Apple Kalender), funktionieren sofort nicht mehr.',
    removeConfirmDevices: '{name} hat diese Tablets gekoppelt. Sie laufen weiter, bis du sie trennst:',
    removeUnpairDevice: 'Tablet trennen',
    removeDevicePaired: 'gekoppelt am {date}',
    removeDeviceUnpaired: '{name} ist getrennt',
    removed: '{name} wurde aus der Familie genommen',
    removedListTitle: 'Aus der Familie genommen',
    removedUntil: 'Rückgängig möglich bis {time}',
    removedHadLogin: 'Login widerrufen',
    undo: 'Rückgängig',
    undone: '{name} ist wieder in der Familie',
    undoneNoLogin: '{name} ist wieder in der Familie. Das Login konnte nicht zurückkommen; bitte neu einladen.',
    errorIsOwner: 'Der Eigentümer kann nicht aus der Familie genommen werden.',
    errorIsSelf: 'Du kannst dich nicht selbst aus der Familie nehmen.',
    errorNeedsOwner: 'Nur der Eigentümer kann ein anderes Elternteil aus der Familie nehmen.',
    errorWindowClosed: 'Die 7 Tage sind vorbei; rückgängig machen geht nicht mehr.',
    errorAlreadyRemoved: 'Diese Person wurde schon aus der Familie genommen.',
    errorDeletionUnavailable: 'Löschen geht gerade nicht. Es ist nichts geplant; versuch es später noch einmal oder schreib uns.',
    errorConfirmName: 'Der Name stimmt nicht. Tippe den Namen deiner Familientafel genau ab.',
    errorExportGone: 'Diese Datei gibt es nicht mehr. Bereite einen neuen Download vor.',
    zipHint: 'Alles als eine ZIP-Datei mit einer lesbaren Zusammenfassung:',
    deleteTitle: 'Die Familientafel löschen',
    deleteBody: 'Alles über eure Familie wird gelöscht: Kalender, Aufgaben, Essen, Nachrichten, Fotos und Einstellungen. Du hast 30 Tage Bedenkzeit.',
    deleteOwnerOnly: 'Nur der Eigentümer kann die Familientafel löschen.',
    deleteButton: 'Familientafel löschen…',
    deleteConfirmTitle: 'Die Familientafel löschen?',
    deletePoints: [
        'In 30 Tagen löschen wir alles von {household}. Danach lässt es sich nicht wiederherstellen.',
        'Bis zu diesem Tag kannst du es mit Doch nicht löschen aufhalten.',
        'Die Tablets zeigen bis dahin einen ruhigen Hinweis und hören danach auf.',
        'Alle Eltern bekommen eine Mail, jetzt und wenn alles gelöscht ist.',
    ],
    deleteExportFirst: 'Zuerst alles herunterladen?',
    deleteExportFirstBody: 'Mach eine Kopie, bevor du löschst. Das geht auch später, bis zum Tag selbst.',
    deleteTypeName: 'Tippe den Namen deiner Familientafel zur Bestätigung',
    deleteTypeNameHint: 'Genau: {household}',
    deleteConfirmButton: 'In 30 Tagen löschen',
    deleteScheduled: 'Die Familientafel wird am {date} gelöscht',
    deleteScheduledBody: 'Bis zu diesem Tag funktioniert alles wie gewohnt. Danach löschen wir alles und alle Eltern bekommen eine Mail.',
    deleteScheduledByAdmin: 'Von AMUMIN geplant, auf euren Wunsch.',
    cancelDelete: 'Doch nicht löschen',
    cancelled: 'Die Familientafel bleibt bestehen',
    banner: 'Diese Familientafel wird am {date} gelöscht.',
    bannerOwner: 'Doch nicht löschen',
    bannerOthers: 'Nur der Eigentümer kann das aufhalten.',
    bannerMore: 'Mehr erfahren',
    formerMember: 'Ehemaliges Familienmitglied',
    formerMemberShared: 'Ehemaliges WG-Mitglied',
    formerMemberResident: 'Ehemaliges Haushaltsmitglied',
    summary: {
        title: 'Daten von {household}',
        intro: 'Das sind alle Daten eurer Familientafel am {date}, so wie AMUMIN sie speichert. Jeder Teil steht in einer eigenen JSON-Datei; du kannst sie mit einem Texteditor öffnen oder in ein anderes Programm einlesen.',
        fileHeader: 'Datei',
        whatHeader: 'Was drinsteht',
        countHeader: 'Zeilen',
        membersTitle: 'Mitglieder',
        memberFormer: 'ehemaliges Familienmitglied',
        memberArchived: 'nicht mehr aktiv',
        notIncludedTitle: 'Was nicht drinsteht',
        notIncluded: 'Geheimnisse (Passwörter, PINs, Kopplungscodes und Zugangsdaten der Tablets), technische Protokolle und vorübergehende Kopien von Antworten anderer Dienste. Die Fotos und Aufnahmen selbst sind nicht dabei; nur wann sie gemacht wurden und wie groß sie sind.',
        rightsTitle: 'Eure Rechte',
        rights: 'Du kannst Daten in der App selbst berichtigen, jemanden aus der Familie nehmen oder die ganze Familientafel unter Einstellungen › Deine Daten löschen. Fragen oder eine Beschwerde? Wende dich an AMUMIN (siehe Datenschutzerklärung in der App); du kannst dich auch bei der niederländischen Datenschutzbehörde (Autoriteit Persoonsgegevens) beschweren.',
        accountTitle: 'Dein Konto',
        accountBody: 'Die E-Mail-Adresse, mit der du dich anmeldest, und wann dein Konto erstellt wurde (account.json).',
        domains: {
            household: {
                title: 'Familie und Tablets',
                body: 'Die Familientafel mit der Art des Haushalts, die Mitglieder, Logins (ohne Passwörter) und ihre Bildschirmauswahl, Zimmer, Tablets, Einladungen und der ungefähre Standort.',
            },
            profile: {
                title: 'Was zu unserer Familie passt',
                body: 'Küche, Glaube, Essen und besondere Tage, mit allen Einwilligungen (auch widerrufenen).',
            },
            calendar: {
                title: 'Kalender',
                body: 'Termine, Wiederholungen, wer mitkommt, Fahrten, Erinnerungen und verknüpfte Kalender.',
            },
            tasks: {
                title: 'Aufgaben und Belohnungen',
                body: 'Aufgaben, wer sie erledigt hat, Punkte, Belohnungen und Anfragen.',
            },
            food: {
                title: 'Essen',
                body: 'Einkäufe, Rezepte, Wochenmenü und Vorrat.',
            },
            // Golf 8 (0049): Kosten delen.
            costs: {
                title: 'Kosten teilen',
                body: 'Ausgaben mit ihrer Aufteilung, Ausgleiche und abgeschlossene Zeiträume des Hauses.',
            },
            family: {
                title: 'Familie und Nachrichten',
                body: 'Wunschlisten, Kontakte, verknüpfte Familien, Gespräche und Nachrichten.',
            },
            rooms: {
                title: 'Zimmer und Putzen',
                body: 'Wer in welchem Zimmer schläft, Aufgaben im Haushalt, der Putzplan (abwesend und Tausch), das Putzprotokoll und Kindersperren (ohne den Code).',
            },
            media: {
                title: 'Fotos und Aufnahmen',
                body: 'Angaben zu Fotos und Aufnahmen: Art, Größe und Datum.',
            },
            care: {
                title: 'Check-in und Familienkreis',
                body: "Wann 'Alles gut' getippt wurde, Hinweise und wer sie bekam, Pausen, der Kreis mit seinen Rechten und die Zustimmungen der älteren Person.",
            },
            weather_prayer: {
                title: 'Wetter und Gebetszeiten',
                body: 'Einstellungen für den Wettertipp und die Gebetszeiten.',
            },
            growth: {
                title: 'Wachstum',
                body: 'Größe und Gewicht mit den Einwilligungen, wenn ihr das nutzt.',
            },
            school: {
                title: 'Schule',
                body: 'Fächer und Ergebnisse, wenn ihr das nutzt.',
            },
            security: {
                title: 'Sicherheit',
                body: 'Vertrauenswürdige Netzwerke, Sicherheitshinweise und das Audit-Log (wer was getan hat, ohne Inhalt).',
            },
            privacy: {
                title: 'Datenschutzanfragen',
                body: 'Downloads wie dieser, wer aus der Familie genommen wurde und eine geplante Löschung.',
            },
            billing: {
                title: 'Abonnement und Rechnungen',
                body: 'Dein Abonnement und Probemonat, was sich geändert hat (Kündigen, Bezahlen) und die Rechnungen. Rechnungen bewahren wir 7 Jahre auf, auch nach dem Löschen (gesetzliche Pflicht).',
            },
            // 0068: Gezond op gewicht (persoonlijk).
            kompas: {
                title: 'Gesundes Gewicht',
                body: 'Nur deine eigenen Daten: deine Einwilligung, Profil und Ziel, was du gegessen hast, Wasser, Bewegung, Wiegungen und deine Kachel auf der Tafel. Liegt in deinem eigenen Bereich; niemand sonst sieht es.',
            },
            // 0069: Geldzaken.
            money: {
                title: 'Geldsachen',
                body: 'Deine eigenen Bereiche, Buchungen (die IBAN anderer verdeckt), Regeln, Ziele und Vermögenswerte. Nur im Download deines eigenen Bereichs.',
            },
        },
    },
};
export const appEditorG4De = {
    discardTitle: 'Änderungen verwerfen?',
    discardBody: 'Was du eingegeben hast, geht dann verloren.',
    discardKeep: 'Weiter bearbeiten',
    discardConfirm: 'Verwerfen',
};
export const appDevicesG4De = {
    layout: 'Ansicht',
    layoutAuto: 'Automatisch',
    layoutAutoHint: 'Passt sich selbst an den Bildschirm an, auch beim Drehen: kompakt auf einem kleinen Bildschirm, breit auf einem großen im Querformat, sonst groß.',
    layoutLarge: 'Groß',
    layoutLargeHint: 'Die ganze Tafel nebeneinander, wie auf dem iPad im Wohnzimmer.',
    layoutCompact: 'Kompakt',
    layoutCompactHint: 'Weniger nebeneinander und alles größer, lesbar aus 2 Metern. Für ein kleines Tablet oder ein iPad mini.',
    layoutShown: 'Ansicht: {layout}',
    // Tablet-breed: breed (en automatisch op elk scherm).
    layoutWide: 'Breit',
    layoutWideHint: 'Kalender, Aufgaben und eine Spalte Heute nebeneinander. Für ein Tablet ab 10 Zoll im Querformat.',
};
export const appProfileDaysG4De = {
    expectedTag: 'erwartet',
    sheet: {
        expected: 'Dieser Tag steht noch nicht fest.',
        when: 'Fällt auf {dates}.',
        confirm: 'Tag bestätigen',
        confirmHint: 'Bestätige oder verschiebe ihn unter Was zu unserer Familie passt, Besondere Tage.',
    },
};
export const appModulesG4De = {
    offBecause: 'Aus ({names} ist aus)',
    exampleA: 'Lena',
    exampleB: 'Jonas',
    holidaysIslamic: 'Auch Zuckerfest und Opferfest nach eurer Tradition.',
};
export const appWerklijstG4De = {
    progressRegion: 'Fortschritt',
};
export const prayerRamadanDe = {
    word: {
        turkish: 'Ramazan',
        arabic: 'Ramadan',
    },
    imsak: {
        turkish: 'İmsak',
        arabic: 'Imsak',
    },
    sabah: {
        turkish: 'Sabah',
        arabic: 'Fajr',
    },
    iftar: {
        turkish: 'İftar',
        arabic: 'Iftar',
    },
    day: '{word} · Tag {n}',
    last: '{word} · letzter Tag',
    countdown: 'noch {n} Min.',
    now: 'Zeit für {iftar}',
    tomorrow: 'Morgen',
    eve: 'Morgen beginnt der {word}',
};
//# sourceMappingURL=golf4App.de.js.map